/**
 * How the address box offers a building's entrances, for this person (#420): each door a row
 * of the list, after the address as letters, or whatever the firm chose.
 *
 * Beside the language and the theme in the person's menu, and kept the same way: on the
 * membership, so it follows the dispatcher to the next desk. Left on the firm's choice, it
 * moves when the administrator changes the firm's; chosen, it stays the dispatcher's own.
 */

import { useTranslation } from 'react-i18next';

import { usePlacesFeatures } from '../places/features';
import { Select } from '../ui';
import { usePreferences } from './preferencesContext';

type Choice = 'firm' | 'list' | 'after';

export function EntrancesSelect({ className = 'w-auto' }: { className?: string }) {
  const { t } = useTranslation();
  const { current, save } = usePreferences();
  const firm = usePlacesFeatures();

  const chosen: Choice = current.entrances ?? 'firm';
  const firmWay = firm.entrancesAfterAddress ? 'after' : 'list';

  return (
    <Select
      value={chosen}
      onChange={(event) => {
        const next = event.target.value as Choice;

        save({ entrances: next === 'firm' ? null : next });
      }}
      aria-label={t('person.entrances')}
      className={className}
    >
      <option value="firm">{t('person.entrancesFirm', { way: t(`person.entrancesWay.${firmWay}`) })}</option>
      <option value="list">{t('person.entrancesWay.list')}</option>
      <option value="after">{t('person.entrancesWay.after')}</option>
    </Select>
  );
}
